var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 176,
    viewBox: "0 0 177 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8084 0.159424H0V43.9823H43.8229V0.159424H43.8084ZM38.8523 39.0117H4.95616V5.13008H38.8523V39.0117Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7235 15.2453H15.0723V28.8965H28.7235V15.2453Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.089 0.159424H132.266V43.9823H176.089V0.159424ZM171.132 39.0117H137.236V5.13008H171.132V39.0117Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.003 15.2453H147.352V28.8965H161.003V15.2453Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 175.958H43.8229V132.135H0V175.958ZM4.95616 137.106H38.8523V171.002H4.95616V137.106Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7235 147.221H15.0723V160.872H28.7235V147.221Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2846 50.2572H71.5015H74.9505H77.0808V76.0235V82.1824V85.6894H87.4279V107.253H93.6303H97.0794H108.803V97.5871H97.0794V76.0235H92.2536H87.4279H86.7323V66.6473H105.818H107.586H115.469V48.8081H119.281V39.1566H106.557V15.2453H99.3691V46.9821H92.9492V32.9831H83.2833V40.6058H74.9505V19.0421H70.1103H65.2846H64.6035V0H54.9375V19.0421V25.2011V28.6936H65.2846V50.2572Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0093 26.2445H86.6753V9.9558H89.4287V0.304321H74.2559V9.9558H77.0093V26.2445Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6476 53.9961H62.9961V62.807H72.6476V53.9961Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8234 52.3875V66.3285V69.6616V76.6756H21.2308V80.6029H16.0428H12.6952H0.855469V90.2543H6.37681V109.267H16.0428V90.2543H29.9693V86.3271H52.4604V81.5013H52.4749V75.98H71.488V66.3285H52.4749V56.6481H61.3873V34.6497H51.7214V52.3875H42.8234Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M176.35 111.253H171.525V121.6H149.961V127.802V131.251V139.599V142.975V149.25H166.438V175.944H176.089V139.599H167.235H166.438H159.612V131.251H176.22V126.426H176.35V111.253Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.207 119.296H137.396V128.947H146.207V119.296Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M165.567 108.036H147.815V99.1377H133.888H130.541H123.541V77.5451H117.339H113.89H102.166V87.1966H113.89V108.76H118.716V108.789H124.237V127.802H133.888V108.789H143.554V117.687H165.567V108.036Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.41 162.133H143.222V153.395V144.685V133.396H124.18H118.021H114.529V143.729H92.9649V149.946V153.395V165.118H88.0957V175.813H106.065V165.118H102.616V153.395H118.021H124.18H133.571V162.133V163.901V171.785H151.41V175.944H161.061V158.322H151.41V162.133Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3563 92.7179H63.3287H57.1552H53.6627V103.065H32.0991V107.253H20.7231V114.861H0.173828V124.513H20.7231H25.3604H35.8959V124.44H41.765H49.3877V116.441H41.765V112.716H63.3287V107.891V103.065V102.369H82.3563V92.7179Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2257 127.208V112.021H67.5743V114.789H56.1113V124.44H67.5743V127.208H77.2257Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3403 111.514H83.5293V121.165H92.3403V111.514Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M136.135 75.7626H127.324V85.4141H136.135V75.7626Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6341 166.162H49.3887V175.813H62.6341V166.162Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M108.297 137.831V131.614V128.179V116.441H98.646V128.179H77.0823V133.005H77.0533V138.512H67.112V129.962H49.3887V139.613H58.0402V148.178H77.0533V157.844H68.1554V175.813H77.8069V162.104H86.7048V148.178V144.83V137.831H108.297Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5323 151.685H56.8809V160.496H66.5323V151.685Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M125.976 157.974H117.121V175.944H125.976V157.974Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M176.088 59.8797V57.3582V50.2137H144.424V59.8797H148.83V70.3717H139.932V92.3701H149.598V74.6323H158.496V67.0096H166.828V88.5733H176.088V59.8797Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M167.524 92.8338H164.771V81.3709H155.105V92.8338H152.352V102.485H167.524V92.8338Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M124.513 11.0717H114.861V33.0701H124.513V11.0717Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M124.889 0H102.891V9.65148H124.889V0Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M122.498 58.8073V68.4588H139.772V58.8073H135.961V50.2572H126.309V58.8073H122.498Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3605 48.4313H27.709V73.6323H37.3605V48.4313Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.042 55.054H2.86914V64.7054H18.042V55.054Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/QR-code.8223590e9a1ad902d7d0c365bb0e25ea.svg";
export { ForwardRef as ReactComponent };